import { router } from '@config/routing';
import environment from '@config/environment';
import { RouterProvider } from 'react-router-dom';
import useInitialization from '@hooks/useInitialization';
import { StatsigProvider } from '@statsig/react-bindings';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { StatsigUserSync } from '@/components/StatsigUserSync';
import { Toaster } from '@/components/design-system/toaster';
import { ErrorBoundaryWrapper } from '@/components/ErrorBoundary/ErrorBoundaryWrapper';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
    },
  },
});

function App() {
  useInitialization();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.storifyme.xyz/static/web-components/storifyme-elements.min.js";
    script.defer = true;
    script.async = true;
    script.type = "text/javascript";
    document.head.appendChild(script);
  }, []);

  return (
    <ErrorBoundaryWrapper>
      <QueryClientProvider client={queryClient}>
        <StatsigProvider
          sdkKey={environment.STATSIG_API_KEY}
          user={{ userID: 'anonymous' }}
          options={{
            environment: { tier: environment.STATSIG_ENVIRONMENT },
          }}
        >
          <StatsigUserSync>
            <RouterProvider router={router} />
            <Toaster />
          </StatsigUserSync>
        </StatsigProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </ErrorBoundaryWrapper>
  );
}

export default App;
